import {AuthType, AuthTypeEnum, BaseAuthenticationMethod} from './base-authentication-method';

export class Sso extends BaseAuthenticationMethod {
    type = 'sso';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
}
